import { useLocStrings } from '@office-start/loc-service';
export var useStorageErrorResources = function () {
    var locStrings = useLocStrings().data;
    var storageResources = locStrings === null || locStrings === void 0 ? void 0 : locStrings.storageErrorResources;
    if (!locStrings || !storageResources)
        return undefined;
    return storageResources;
};
//# sourceMappingURL=useStorageErrorResources.js.map